import React from "react";
import { PageTitle, Paragraph, ParaTitle, Pagination } from "../common";
import { Typography } from "@mui/material";

const Roles = () => {
    return (
        <div>
            <PageTitle title='Roles' />
            <Paragraph paragraph='NOTE: Users permissions have been updated over the years so illustrations might not completely represent the current roles.' />

            <ParaTitle paraTitle='User' />
            <ul>
                <Typography variant="body1" component="li">Can add an event</Typography>
                <Typography variant="body1" component="li">Can delete an event while it is in the draft status</Typography>
                <Typography variant="body1" component="li">Can update an event while it is in the draft status</Typography>
            </ul>

            <ParaTitle paraTitle='Reviewer' />
            <ul>
                <Typography variant="body1" component="li">Can add notes as a reviewer for an event under review</Typography>
                <Typography variant="body1" component="li">Can close a review</Typography>
                <Typography variant="body1" component="li">Upload files for an event that is under review</Typography>
                <Typography variant="body1" component="li">View an event that is under review</Typography>
                <Typography variant="body1" component="li">View a file for an event under review</Typography>
                <Typography variant="body1" component="li">Able to view a list of events that is pending review</Typography>
                <Typography variant="body1" component="li">View notes for an event under review</Typography>
            </ul>

            <ParaTitle paraTitle='Approver' />
            <ul>
                <Typography variant="body1" component="li">Can add notes for an event in the current facility</Typography>
                <Typography variant="body1" component="li">Can approve an event</Typography>
                <Typography variant="body1" component="li">View events in the current facility</Typography>
                <Typography variant="body1" component="li">View files for an event in the current facility</Typography>
                <Typography variant="body1" component="li">Able to view a list of events that is pending approval</Typography>
                <Typography variant="body1" component="li">View notes for an event in the current facility</Typography>
            </ul>

            <ParaTitle paraTitle='Risk Manager' />
            <ul>
                <Typography variant="body1" component="li">Able to add a new note to the comments page</Typography>
                <Typography variant="body1" component="li">Assign an event to a Reviewer</Typography>
                <Typography variant="body1" component="li">Delete uploaded files in event</Typography>
                <Typography variant="body1" component="li">Edit the user management of the current facility</Typography>
                <Typography variant="body1" component="li">Able to see and generate reports</Typography>
                <Typography variant="body1" component="li">Request approval for an event</Typography>
                <Typography variant="body1" component="li">Can update an event</Typography>
                <Typography variant="body1" component="li">Can upload files to event</Typography>
                <Typography variant="body1" component="li">Able to view the dashboard tab for closed events</Typography>
                <Typography variant="body1" component="li">Able to view the dashboard tab for reviews completed</Typography>
                <Typography variant="body1" component="li">Able to view any event that is not a draft</Typography>
                <Typography variant="body1" component="li">View uploaded files</Typography>
                <Typography variant="body1" component="li">Able to view the dashboard tab for new events</Typography>
                <Typography variant="body1" component="li">Able to view the dashboard tab for pending approvals</Typography>
                <Typography variant="body1" component="li">Able to view the dashboard tab for pending reviews</Typography>
                <Typography variant="body1" component="li">Able to view the dashboard tab for approvals rejected</Typography>
                <Typography variant="body1" component="li">Able to view the user management screen</Typography>

            </ul>

            <ParaTitle paraTitle='Organization Manager' />
            <ul>
                <Typography variant="body1" component="li">Is able to change between different facilities</Typography>
                <Typography variant="body1" component="li">Can edit facility settings (CRUD)</Typography>
            </ul>

            <ParaTitle paraTitle='Admin' />
            <ul>
                <Typography variant="body1" component="li">Can change organizations</Typography>
                <Typography variant="body1" component="li">Able to create Admin role users</Typography>
                <Typography variant="body1" component="li">Can delete an event</Typography>
                <Typography variant="body1" component="li">Able to edit Admin role users</Typography>
                <Typography variant="body1" component="li">Can create, edit, remove, and assign RBAC permissions</Typography>
                <Typography variant="body1" component="li">Can edit organization settings (CRUD)</Typography>
            </ul>

            <Pagination
                pagination={{
                    prev: { name: 'Home', link: '/' }
                }}
            />
        </div>
    );
};

export default Roles;
